/* LWA collection discovery: client-side facet filtering over the full collection grid.
   Every card is already in the DOM, so filtering is a class/hidden toggle - no fetching. */
(function () {
  'use strict';

  var root = document.querySelector('[data-lwa-cd-filters]');
  var grid = document.querySelector('[data-lwa-cd-grid]');
  var mapEl = document.getElementById('lwa-cd-map');
  if (!root || !grid || !mapEl) return;

  var MAP;
  try { MAP = JSON.parse(mapEl.textContent); } catch (e) { return; }

  // Six axes (REA Step 16). Keys must match GROUPS in scripts/collection-discovery/gen-snippet.js.
  var GROUPS = ['f', 'c', 'r', 's', 'j', 'm'];
  var GROUP_EL_ID = { f: 'format', c: 'color', r: 'room', s: 'style', j: 'subject', m: 'technique' };
  // Shared links from before the Step 16 split still resolve: watercolor moved from Style to
  // Technique, and the old "Sets & Large Scale" subject became the Format axis.
  var LEGACY = { 's:watercolor': ['m', ['watercolor']], 'j:sets': ['f', ['gallery-wall', 'triptych', 'two-piece', 'five-piece', 'large']] };

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-lwa-cd-card]'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-lwa-cd-chip]'));
  var searchEl = root.querySelector('[data-lwa-cd-search]');
  var countEl = root.querySelector('[data-lwa-cd-count]');
  var clearEl = root.querySelector('[data-lwa-cd-clear]');
  var emptyEl = document.querySelector('[data-lwa-cd-empty]');

  // selected[group] = Set of values
  var selected = {};
  GROUPS.forEach(function (g) { selected[g] = Object.create(null); });
  var query = '';

  var items = cards.map(function (el) {
    var h = el.getAttribute('data-handle');
    var f = MAP[h] || {};
    return {
      el: el,
      handle: h,
      title: el.getAttribute('data-title') || '',
      f: f,
      hay: (h + ' ' + (el.getAttribute('data-title') || '')).replace(/-/g, ' ')
    };
  });

  function sel(g) { return Object.keys(selected[g]); }
  function anySel() { return GROUPS.some(function (g) { return sel(g).length > 0; }); }

  function matchesGroup(item, g) {
    var s = sel(g);
    if (!s.length) return true;
    var vals = item.f[g] || [];
    for (var i = 0; i < s.length; i++) if (vals.indexOf(s[i]) !== -1) return true;
    return false;
  }

  function matchesQuery(item) {
    if (!query) return true;
    // every whitespace-separated term must appear somewhere in handle+title
    var terms = query.split(/\s+/);
    for (var i = 0; i < terms.length; i++) if (item.hay.indexOf(terms[i]) === -1) return false;
    return true;
  }

  // matches everything except the named group (for facet counts)
  function matchesExcept(item, skip) {
    if (!matchesQuery(item)) return false;
    for (var i = 0; i < GROUPS.length; i++) {
      var g = GROUPS[i];
      if (g === skip) continue;
      if (!matchesGroup(item, g)) return false;
    }
    return true;
  }

  function apply() {
    var shown = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      // skip=null means no group is skipped, so this is the full query + all-groups test
      var ok = matchesExcept(it, null);
      if (ok) { it.el.hidden = false; shown++; } else { it.el.hidden = true; }
    }

    // per-chip counts, computed against the other groups' selections
    var pools = {};
    GROUPS.forEach(function (g) {
      pools[g] = items.filter(function (it) { return matchesExcept(it, g); });
    });
    chips.forEach(function (chip) {
      var g = chip.getAttribute('data-group');
      var v = chip.getAttribute('data-value');
      var n = 0;
      var pool = pools[g];
      for (var i = 0; i < pool.length; i++) {
        if ((pool[i].f[g] || []).indexOf(v) !== -1) n++;
      }
      var nEl = chip.querySelector('[data-lwa-cd-chipn]');
      if (nEl) nEl.textContent = n;
      var isOn = chip.getAttribute('aria-pressed') === 'true';
      if (n === 0 && !isOn) {
        chip.setAttribute('data-empty', '1');
        chip.setAttribute('aria-disabled', 'true');
      } else {
        chip.removeAttribute('data-empty');
        chip.removeAttribute('aria-disabled');
      }
    });

    // per-group "2 selected" hints
    GROUPS.forEach(function (g) {
      var el = root.querySelector('[data-lwa-cd-groupsel="' + GROUP_EL_ID[g] + '"]');
      if (!el) return;
      var n = sel(g).length;
      el.textContent = n ? n + ' selected' : '';
    });

    if (countEl) {
      countEl.textContent = (anySel() || query)
        ? 'Showing ' + shown + ' of ' + items.length + ' collections'
        : items.length + ' collections';
    }
    if (clearEl) clearEl.hidden = !(anySel() || query);
    if (emptyEl) emptyEl.hidden = shown !== 0;

    writeHash();
  }

  function writeHash() {
    var parts = [];
    GROUPS.forEach(function (g) {
      var s = sel(g);
      if (s.length) parts.push(g + '=' + s.join(','));
    });
    if (query) parts.push('q=' + encodeURIComponent(query));
    var hash = parts.length ? '#' + parts.join('&') : '';
    var url = location.pathname + location.search + hash;
    history.replaceState(null, '', url);
  }

  function readHash() {
    var h = location.hash.replace(/^#/, '');
    if (!h) return;
    h.split('&').forEach(function (pair) {
      var bits = pair.split('=');
      var k = bits[0];
      var v = decodeURIComponent(bits.slice(1).join('=') || '');
      if (k === 'q') { query = v.toLowerCase(); if (searchEl) searchEl.value = v; return; }
      if (GROUPS.indexOf(k) === -1 || !v) return;
      v.split(',').forEach(function (val) {
        var alias = LEGACY[k + ':' + val];
        if (alias) { alias[1].forEach(function (a) { selected[alias[0]][a] = true; }); return; }
        selected[k][val] = true;
      });
    });
    chips.forEach(function (chip) {
      var g = chip.getAttribute('data-group');
      var v = chip.getAttribute('data-value');
      if (selected[g] && selected[g][v]) {
        chip.setAttribute('aria-pressed', 'true');
        var d = chip.closest('details');
        if (d) d.open = true;
      }
    });
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var g = chip.getAttribute('data-group');
      var v = chip.getAttribute('data-value');
      var on = chip.getAttribute('aria-pressed') === 'true';
      if (on) { delete selected[g][v]; chip.setAttribute('aria-pressed', 'false'); }
      else if (chip.getAttribute('data-empty') === '1') { return; }
      else { selected[g][v] = true; chip.setAttribute('aria-pressed', 'true'); }
      apply();
    });
  });

  if (searchEl) {
    var t;
    searchEl.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        query = searchEl.value.trim().toLowerCase().replace(/-/g, ' ');
        apply();
      }, 120);
    });
  }

  if (clearEl) {
    clearEl.addEventListener('click', function () {
      GROUPS.forEach(function (g) { selected[g] = Object.create(null); });
      query = '';
      if (searchEl) searchEl.value = '';
      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      apply();
      if (searchEl) searchEl.focus();
    });
  }

  readHash();
  apply();
})();
